import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import { Menu, Icon, Dropdown } from 'semantic-ui-react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Alert from 'react-s-alert';
import {toggleSidebar} from '../actions/system';
import Dls from '../lib';
class UserLayout extends Component {
    constructor() {
        super();
        this.state = {
            smallMenu: false
        };
    }

    render() {
        const { isAuthenticated, user, toggleSidebar, location, sideBarOpen, component: Component, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        <div>
                            <div id="main-content">
                                <Component {...props} />
                                <Alert stack={{limit: 3}} />
                            </div>
                            <Menu fixed="top">
                                <Menu.Item
                                    className="no-border"
                                    onClick={() => this.props.history.push('/')}
                                >
                                    <Icon name="computer" />
                                </Menu.Item>

                                {/* <Menu.Item className="no-border drop-left-padding">
                                    <Input
                                        className="icon"
                                        icon="search"
                                        placeholder="Search..."
                                        onChange={this.doSearch.bind(this)}
                                    />
                                </Menu.Item> */}

                                <Menu.Menu position="right">
                                    <Dropdown item text='Orders'>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => {
                                                this.props.history.push(`/mobile/customer-orders/${Dls.pagination.orders('Customer Order')}`)
                                            }}>Customer Order</Dropdown.Item>
                                            <Dropdown.Item onClick={() => {
                                                this.props.history.push(`/mobile/vendor-orders/${Dls.pagination.orders('Vendor Order')}`)
                                            }}>Vendor Order</Dropdown.Item>
                                            <Dropdown.Item onClick={() => {
                                                this.props.history.push(`/mobile/customer-returns/${Dls.pagination.orders('Customer Return')}`)
                                            }}>Customer Return</Dropdown.Item>
                                            <Dropdown.Item onClick={() => {
                                                this.props.history.push(`/mobile/vendor-returns/${Dls.pagination.orders('Vendor Return')}`)
                                            }}>Vendor Return</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Menu.Item
                                        className="no-border"
                                        position="right"
                                    >
                                        <div className="display-inline">
                                            {this.props.user.name}
                                        </div>
                                    </Menu.Item>
                                </Menu.Menu>
                            </Menu>
                        </div>
                    ) : (
                        <Redirect to="/auth/login" />
                    )
                }
            />
        );
    }
}
//
UserLayout.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    component: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.object,
    toggleSidebar: PropTypes.func,
    sideBarOpen: PropTypes.bool,
    user: PropTypes.object
};

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.authenticated,
        sideBarOpen: state.system.ui.sidebar,
        user: state.auth.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSidebar
    }, dispatch);
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserLayout));



// WEBPACK FOOTER //
// ./src/routes/MobileLayout.js